export const IGetLanguageUseCaseType = Symbol('IGetLanguageUseCase');
